'use client'

import * as React from 'react'
import { ThemeProvider as NextThemesProvider } from 'next-themes'
import { BreadcrumbProvider } from './breadcrumb-context.tsx'
import { AnimationPreferencesProvider } from './animation-preferences-context.tsx'
import { ModelPreferencesProvider } from './model-preferences-context.tsx'

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
      enableColorScheme
    >
      <AnimationPreferencesProvider>
        <ModelPreferencesProvider>
          <BreadcrumbProvider>
            {children}
          </BreadcrumbProvider>
        </ModelPreferencesProvider>
      </AnimationPreferencesProvider>
    </NextThemesProvider>
  )
}
